export function formatWholePart(amount: string | number): string {
	return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

function _baseFormat(amt: string, fractionalDigits: number = 3): string {
	const parsed = parseFloat(amt)
	if (!Number.isFinite(parsed)) {
		return '0'
	}
	const amount = '' + parsed.toFixed(fractionalDigits)
	const split = amount.split('.')
	const decimals = split[1] || ''

	for (let i = decimals.length - 1; i >= 0; i--) {
		if (decimals.charAt(i) !== '0') {
			return formatWholePart(split[0]) + '.' + decimals.substr(0, i + 1)
		}
		if (i === 0) {
			return formatWholePart(split[0])
		}
	}
	return formatWholePart(split[0])
}

export function formatCurrency(amount: string): string {
	return _baseFormat(amount)
}

export function formatLeaderboardScore(amount: string): string {
	return _baseFormat(amount, 2)
}
